import { render } from "./Commissions.vue?vue&type=template&id=e9e33794&ts=true"
import script from "./Commissions.vue?vue&type=script&lang=ts"
export * from "./Commissions.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__